import { Component } from '@angular/core';

@Component({
    templateUrl: './not-found.component.html',
    styleUrls: ['../../assets/scss/not-found/not-found.scss'],
    standalone: false
})

export class NotFoundComponent {}

